import { LANG_STORAGE_KEY, type Lang } from './detect';

// Сохранение выбора языка. Три получателя, и все три обязательны:
//
// 1. localStorage['sp_lang'] — канонический источник и он же общий с лендингом
//    (тот же origin, тот же ключ), поэтому выбор в кабинете виден лендингу и наоборот.
// 2. cookie NG_TRANSLATE_LANG_KEY — из неё api/cookies.ts::getLangId() берёт `lang-id`
//    для каждого запроса к API (api/client.ts). Без записи cookie бэк продолжал бы
//    получать 'ru' при английском кабинете. Cookie пишем здесь, а не в api/cookies.ts,
//    чтобы shared-слой не зависел от api-слоя; читатель остаётся там.
// 3. <html lang> — для браузера, скринридеров и как последний фолбэк в getLangId().

const LANG_COOKIE = 'NG_TRANSLATE_LANG_KEY';
const TWO_YEARS_SECONDS = 60 * 60 * 24 * 365 * 2;

export function persistLanguage(lang: Lang) {
  try {
    localStorage.setItem(LANG_STORAGE_KEY, lang);
  } catch {
    // Приватный режим или запрещённые site data — язык просто не запомнится.
  }

  document.cookie = `${LANG_COOKIE}=${lang}; path=/; max-age=${TWO_YEARS_SECONDS}; SameSite=Lax`;
  document.documentElement.setAttribute('lang', lang);
}
